import React from "react";
import MessEditSvg from "../../assets/taiga-uikit/icons/message-edit.svg?react";
import { _size } from "../../core/core";
import "./Notification.css";

interface NotificationProps {
  icon_left?: boolean | React.ReactNode;
  type?: "warning" | "info" | "error" | "success";
  size?: string;
  children?: React.ReactNode;
}

export const Notification: React.FC<NotificationProps> = ({
  icon_left = true,
  type = "warning",
  size = _size.M,
  children,
}) => {
  const getIcon = () => {
    if (icon_left !== null) {
      if (icon_left === true) {
        return <MessEditSvg />;
      } else {
        return icon_left;
      }
    }
    return <></>;
  };

  return (
    <div className={`notification-${type} size-${size}`}>
      {getIcon()}
      {children}
    </div>
  );
};
